



import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  FaCarSide,
  FaUsers,
  FaDoorOpen,
  FaCogs,
  FaGasPump,
  FaSnowflake,
  FaExchangeAlt
} from "react-icons/fa";

export default function VehicleFullCard({ v }) {
  const [mainImage, setMainImage] = useState(v.image);

  return (
    <div className="car-full-wrapper">

      <h2 className="car-full-title">{v.name}</h2>

      <div className="car-full-row">

        {/* LEFT SIDE */}
        <div className="car-full-left">
          <img className="car-full-main-img" src={mainImage} alt={v.name} />

          <div className="car-full-thumbs">
            {(v.gallery || []).map((img, idx) => (
              <img
                key={idx}
                src={img}
                className="car-full-thumb"
                onClick={() => setMainImage(img)}
                alt="thumb"
              />
            ))}
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="car-full-right">

          <h3 className="car-spec-heading">Specifications</h3>

          <table className="car-spec-table">
            <tbody>
              <tr>
                <td><FaCarSide className="spec-icon" /> Body</td>
                <td>{v.body}</td>
              </tr>

              <tr>
                <td><FaUsers className="spec-icon" /> Seating</td>
                <td>{v.seats}</td>
              </tr>

              <tr>
                <td><FaDoorOpen className="spec-icon" /> Doors</td>
                <td>{v.doors}</td>
              </tr>

              <tr>
                <td><FaCogs className="spec-icon" /> Engine</td>
                <td>{v.engine}</td>
              </tr>

              <tr>
                <td><FaExchangeAlt className="spec-icon" /> Transmission</td>
                <td>{v.transmission}</td>
              </tr>

              <tr>
                <td><FaGasPump className="spec-icon" /> Fuel Type</td>
                <td>{v.fuel}</td>
              </tr>

              <tr>
                <td><FaSnowflake className="spec-icon" /> AC</td>
                <td>{v.ac}</td>
              </tr>
            </tbody>
          </table>

       
<a
  href={`https://wa.me/919730707888?text=Hello%20Aaryan%20Travels%2C%0AI%20want%20to%20book%20the%20vehicle%20*${encodeURIComponent(
    v.name
  )}*%20for%20corporate%20travel.%0APlease%20assist%20me%20with%20availability%20and%20pricing.`}
  target="_blank"
  rel="noopener noreferrer"
  className="car-full-btn"
>
  Book Now
</a>

          {/* <Link to="/book" className="car-full-btn">Book Now</Link> */}
        </div>

      </div>
    </div>
  );
}
